module.exports = __webpack_public_path__ + "assets/basketball.jpg?b782371c0179c1617876905952a7b8f8";